// extracted by mini-css-extract-plugin
export default {"container":"ArS4E0"};